import React from 'react';
import { Input, Button } from './StyledComponents';
import { Checkbox } from './ui/Checkbox';
import { ErrorMessage as FormError } from './ui/ErrorMessage';
import { Form } from './ui/Form';
import { Label } from './ui/Label';

interface UserLoginProps {
    loginData: {
        username: string;
        password: string;
        agree: boolean;
    };
    valid: boolean[];
    loginError: string;
    onLogin: () => void;
    onInputChange: (value: string, id?: string) => void;
    onCheckboxChange: (selected: boolean, id?: string) => void;
    isMobile?: boolean; // default false
}

const UserLogin: React.FC<UserLoginProps> = ({ loginData, valid, loginError, onLogin, onInputChange, onCheckboxChange, isMobile = false }) => {
    const pwPrefix = isMobile ? 'mobile-' : '';
    return (
        <div>
            <p className='mt-10'>
                Um auf die Plattform zuzugreifen, geben Sie bitte Ihre Login-Daten ein.
            </p>
            <div className="mt-4 flex flex-col flex-1">
                <Form className="flex flex-col flex-1">
                    <Input
                        id="username"
                        data-pw={`${pwPrefix}input-username`}
                        label="Benutzername *"
                        value={loginData.username}
                        onChange={onInputChange}
                        onSubmit={onLogin}
                        maxLength={127}
                        invalid={!valid[0]}
                    />
                    <Input
                        id="password"
                        data-pw={`${pwPrefix}input-password`}
                        label="Passwort *"
                        password
                        maxLength={127}
                        onChange={onInputChange}
                        onSubmit={onLogin}
                        invalid={!valid[1]}
                    />
                    <Label>Nutzungsbedingungen *</Label>
                    <div className="flex flex-col mt-4">
                        <Checkbox
                            id="agree"
                            data-pw={`${pwPrefix}checkbox-terms`}
                            label="Ich habe die AGB gelesen und stimme diesen zu"
                            selected={loginData.agree}
                            onSelect={onCheckboxChange}
                            invalid={!valid[2]}
                        />
                    </div>
                    <FormError>{loginError}</FormError>
                    <Button className="mt-auto" data-pw={`${pwPrefix}button-login`} primary onClick={onLogin}>
                        Login
                    </Button>
                </Form>
            </div>
        </div>
    );
}

export default UserLogin;
